// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

// Dinamically change category post item bottom padding
document.addEventListener("DOMContentLoaded", function() {
	setTimeout(function(){
		document.body.classList.add('dom-loaded');
	},200);
});

// Slick slider
if($('.slider').length) {
	$('.slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		infinite: true,
		cssEase: 'linear',
		responsive: [
			{
			breakpoint: 991,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
			},
			{
			breakpoint: 767,
			settings: {
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true
			}
			},
		]
	});
}

// View more link path
if($('body').hasClass('home') && $('.view-more-link-path').length) {
	let viewMorePath = $('.view-more-link-path').find('a').attr('href');
	$('.view-more-link-path__paste').attr('href', viewMorePath);
}

// Sticky header when scrolling up
if($('.header-sticky').is(":visible")) {
	$('body').addClass('sticky-header')
	let lastScrollTop = 0;
	$(window).on('scroll', function() {
		let st = $(this).scrollTop();
		if(st < lastScrollTop) {
			$('body').addClass('sticky-header--sticky');
			$('body').removeClass('sticky-header--not-sticky');
		}
		else {
			$('body').removeClass('sticky-header--sticky');
			$('body').addClass('sticky-header--not-sticky');
		}
		lastScrollTop = st;
	});
}